import React from 'react';
import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';

import { TextAreaField } from 'components/form/base/TextAreaField';
import { CheckboxField } from 'components/form/base/CheckboxField';
import { TImage } from 'types/image';

import { CollageImage } from '../Collage/CollageImage';
import styles from '../Collage/Collage.module.less';
import { VERTICAL_COLLAGE_IMAGE_ASPECT_RATIO } from '../../../../constants/image';

const imageErrorHash = {
  source: 'Не заполнена ссылка на источник',
  author: 'Не указан автор изображения',
};

type TProps = {
  onChange: (value: any) => void;
  verticalCollage: {
    images: [TImage, TImage];
    text: string;
    isLargeGap: boolean;
  };
  error: any;
  errorRef: any;
  name: string;
};

export class FormContentVerticalCollage extends React.Component<TProps> {
  static displayName = 'FormContent:VerticalCollage';

  static defaultProps = {
    verticalCollage: {
      images: [],
      text: '',
      isLargeGap: false,
    },
    onChange: () => undefined,
  };

  onImageChange = (file, index) => {
    const images = this.props.verticalCollage.images.filter(el => el);
    const newImages = [...this.props.verticalCollage.images];

    if (images.length < 2 || index < 2) {
      newImages[index] = file;
    }

    this.props.onChange({
      ...this.props.verticalCollage,
      images: newImages,
    });
  };

  getImageError = (el, index: number): string | null => {
    if (el && this.props.error?.images?.[index]) {
      return imageErrorHash[Object.keys(this.props.error.images[index])[0]];
    }

    if (!el && this.props.error?.images) {
      return 'Загрузите файл';
    }

    return null;
  };

  render() {
    return (
      <Content style={{ paddingTop: 0, paddingBottom: 0 }}>
        <div ref={this.props.errorRef} tabIndex={0}>
          <Card
            className={styles.card}
            title='Вертикальный коллаж'
            type='inner'
          >
            <div className={styles.images}>
              {this.props.verticalCollage.images.map((el, index) => {
                return (
                  <div
                    className={styles.imageWrapper}
                    key={`vertical-collage-${index}`}
                  >
                    <CollageImage
                      onChange={file => this.onImageChange(file, index)}
                      name='hidden-image'
                      value={el}
                      error={this.getImageError(el, index)}
                      aspectRatio={VERTICAL_COLLAGE_IMAGE_ASPECT_RATIO}
                    />
                  </div>
                );
              })}
            </div>

            <TextAreaField
              label='Описание изображений'
              name={`${this.props.name}.text`}
              placeholder='Описание'
              showCount
              maxLength={255}
              rows={10}
            />
            <CheckboxField
              label='Увеличенный отступ'
              name={`${this.props.name}.isLargeGap`}
            />
          </Card>
        </div>
      </Content>
    );
  }
}
